import myAxios from "@/request";

/**
 * 用户注册
 * @param params
 */
interface UsersRegisterRequest {
  user_account: string;
  user_password: string;
  user_checkword: string;
}
export const usersRegister = async (params: UsersRegisterRequest) => {
  return await myAxios.request({
    url: "/user/register",
    method: "POST",
    data: params,
  });
};

/**
 * 用户登录
 * @param params
 */
interface UsersLoginRequest {
  user_account: string;
  user_password: string;
}

export const usersLogin = async (params: UsersLoginRequest) => {
  return await myAxios.request({
    url: "/user/login",
    method: "POST",
    data: params,
  });
};

/**
 * 用户登出
 * @param params
 */
export const usersLogout = async (params: any) => {
  return await myAxios.request({
    url: "/user/logout",
    method: "POST",
    data: params,
  });
};

/**
 * 用户信息获取
 * @param params
 */
export const getUserInfo = async () => {
  return await myAxios.request({
    url: "/user/getInfo",
    method: "GET",
  });
};

/**
 * 用户信息设置
 * @param params
 */

interface UsersSetInfoRequest {
  userName: string;
  email: string;
  phone: string;
  location: string;
  description: string;
}
export const setUserInfo = async (params: UsersSetInfoRequest) => {
  return await myAxios.request({
    url: "/user/setInfo",
    method: "POST",
    data: params,
  });
};

/**
 * 获取用户列表
 * @param params
 */
export const searchUsers = async (params: any) => {
  return await myAxios.request({
    url: "/user/search",
    method: "POST",
    data: params,
  });
};

/**
 * 删除用户
 * @param params
 */
export const deleteUsers = async (params: any) => {
  return await myAxios.request({
    url: "/user/delete",
    method: "POST",
    data: params,
  });
};
